<div *ngFor="let relatoria of relatoriasConsolidadas; let i = index"
     class="page-break">

  <div [ngClass]="{'emAprovacao': relatoria.removeMinuta}">
    <app-print-layout (cancelar)="backClicked()">
      <div class="content">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-md-11">
              <div class="card card-outline card-lightblue">
                
                <div class="card-header no-print">
                  <h3 class="card-title mb-0">
                    Relatoria - {{ relatoria.tipoTrabalhoDescricao }} -
                    {{ relatoria.dadosObtidos?.nomeDocumento }}
                  </h3>
                </div>

                <form class="px-3">
                  <app-relatoria
                    [impressao]="true"
                    [aba]="5"
                    visualizar="true"
                    [dadosObtidos]="relatoria.dadosObtidos"
                    [relatoriaDados]="relatoria.relatoriaDados"
                    [visualizarRelatoriaHidden]="visualizarRelatoriaHidden">
                  </app-relatoria>
                </form>
                <div>
                  <div *ngFor="let element of relatoria.datas">
                    <div *ngFor="let item of element.acoes">
                      <div class="final-section px-3">
                        <p *ngIf="item.acao?.codigo === 3">
                          <span>{{ item.pessoa?.nome }}</span><br>
                          <span>Elaborador</span>
                        </p>
                        <p *ngIf="item.acao?.codigo === 1">
                          <span>{{ item.pessoa?.nome }}</span><br />
                          <span>{{ item.pessoa?.funcao?.descricao }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-print-layout>
  </div>
</div>
